export default "/_next/static/fonts/90278247752bd88741aea65fa9a8fd2c.ttf";